import React from 'react';
import styled from 'styled-components';

interface CardProps {
  children: React.ReactNode;
  [x: string]: unknown;
}

const Card = ({ children, ...rest }: CardProps) => {
  return <Container {...rest}>{children}</Container>;
};

const Container = styled.div`
  height: 400px;
  width: 620px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.padding}px;
  border-radius: 4px;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  margin-top: ${({ theme: { token } }) => token.marginSM}px;
  position: relative;
`;

export default Card;
